<template>
	<div>
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
				<li class="breadcrumb-item active" aria-current="page">Reportes regulatorios</li>
			</ol>
		</nav>
		<div class="container-fluid">
			<div class="row justify-content-md-center" style="margin-top:20px;">
				<div class="col-md-12">
					<vs-card>
						<template slot="header">
							<div class="row p-3 align-items-center border-bottom">
								<div class="col-4">
									<h1 class="text-info"><strong>R08</strong> / 842</h1>
								</div>
								<div class="col-8 float-right">
									<nav>
										<div class="nav nav-tabs" id="nav-tab" role="tablist">
											<vs-button class="nav-link active" id="nav-form-tab" data-bs-toggle="tab"
												data-bs-target="#nav-form" type="button" role="tab" aria-controls="nav-form"
												aria-selected="true">Formulario</vs-button>
											<vs-button class="nav-link" id="nav-envio-tab" data-bs-toggle="tab" data-bs-target="#nav-envio"
												type="button" role="tab" aria-controls="nav-envio" aria-selected="false">Envio</vs-button>
											<vs-button class="nav-link" id="nav-follow-tab" data-bs-toggle="tab" data-bs-target="#nav-follow"
												type="button" role="tab" aria-controls="nav-follow" aria-selected="false">Seguimiento
											</vs-button>
										</div>
									</nav>
								</div>
							</div>
						</template>

						<div class="border-bottom">
							<div class="tab-content" id="nav-tabContent">
								<div class="tab-pane show active" id="nav-form" role="tabpanel" aria-labelledby="nav-form-tab">
									<h2 class="text-warning">Formulario</h2>
									<form class="form-group row" ref="formR08">

										<vs-divider>
											<h5><strong>Informacion solicitada</strong></h5>
										</vs-divider>


										<vs-divider>
											<h6>II. SECCIÓN IDENTIFICADOR DEL PRÉSTAMO</h6>
										</vs-divider>
										<div class="form-group col-4">
											<label for="identificadorPrestamo">identificadorPrestamo:</label>
											<vs-input type="number" name="" class="w-full" :placeholder="this.form.auto"
												v-model.lazy="form.informacionSolicitada.identificarPrestamo.identificadorPrestamo" readonly />
										</div>
										<div class="form-group col-4">
											<label>estatusPrestamo:</label>
											<vs-select class="w-full"
												v-model.lazy="form.informacionSolicitada.identificarPrestamo.estatusPrestamo">
												<vs-select-item v-for="(item, key) in catalog.estatusPrestamo" :key="key" :value="item.item_key"
													:text="item.item_key + ' - ' + item.item_description" />
											</vs-select>
										</div>
										<div class="form-group col-4">
											<label class="vs-input--label">fechaActualizacionEstatus:</label>
											<datepicker placeholder="fechaActualizacionEstatus" :language="lang_es"
												v-model.lazy="form.informacionSolicitada.identificarPrestamo.fechaActualizacionEstatus"
												format="yyyyMMdd" />
										</div>

										<div v-if="form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 101"
											class="col-12 p-0 row m-0">
											<vs-divider>
												<h6>III. SECCIÓN DE DATOS DE IDENTIFICACIÓN DEL PRESTAMISTA</h6>
											</vs-divider>
											<div class="form-group col-6">
												<label>tipoPrestamista:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionPrestamista.tipoPrestamista">
													<vs-select-item v-for="(item, key) in catalog.tipoPrestamista" :key="key"
														:value="item.item_key" :text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-6">
												<label for="nombreRazonDenominacionSocial">nombreRazonDenominacionSocial: <button type='button'
														class="btn btn-xm p-0 text-primary"
														@click="detailField('nombreRazonDenominacionSocial')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="text" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionPrestamista.nombreRazonDenominacionSocial"
													@input="toUpperCase($event)" />
											</div>
											<div class="form-group col-4">
												<label for="apellidoPaterno">apellidoPaterno: <button type='button'
														class="btn btn-xm p-0 text-primary" @click="detailField('apellidoPaterno')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="text" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionPrestamista.apellidoPaterno"
													@input="toUpperCase($event)" />
											</div>
											<div class="form-group col-4">
												<label for="apellidoMaterno">apellidoMaterno: <button type='button'
														class="btn btn-xm p-0 text-primary" @click="detailField('apellidoMaterno')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="text" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionPrestamista.apellidoMaterno"
													@input="toUpperCase($event)" />
											</div>
											<div class="form-group col-4">
												<label for="paisOrigen">paisOrigen:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionPrestamista.paisOrigen">
													<vs-select-item v-for="(item, key) in catalog.paisOrigen" :key="key" :value="item.item_key"
														:text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
										</div>

										<div v-if="form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 101
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 102
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 103
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 109" class="col-12 p-0 row m-0">
											<vs-divider>
												<h6>IV. SECCIÓN DE DATOS DE LA CUENTA</h6>
											</vs-divider>
											<div class="form-group col-12">
												<label for="identificadorCuenta">identificadorCuenta: <button type='button'
														class="btn btn-xm p-0 text-primary" @click="detailField('identificadorCuenta')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosCuenta.identificadorCuenta" />
											</div>
										</div>

										<div v-if="form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 101
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 102
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 103
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 109" class="col-12 p-0 row m-0">
											<vs-divider>
												<h6>V. SECCIÓN DE DATOS DE LA OPERACIÓN</h6>
											</vs-divider>
											<div class="form-group col-8">
												<label>clasificacionContable:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.clasificacionContable">
													<vs-select-item v-for="(item, key) in catalog.clasificacionContable" :key="key"
														:value="item.item_key" :text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">fechaContratacionApertura:</label>
												<datepicker placeholder="fechaContratacionApertura" :language="lang_es"
													v-model.lazy="form.informacionSolicitada.datosOperacion.fechaContratacionApertura"
													format="yyyyMMdd" />
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">fechaVencimiento:</label>
												<datepicker placeholder="fechaVencimiento" :language="lang_es"
													v-model.lazy="form.informacionSolicitada.datosOperacion.fechaVencimiento" format="yyyyMMdd" />
											</div>
											<div class="form-group col-8">
												<label>periodicidadPagosCapital:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.periodicidadPagosCapital">
													<vs-select-item v-for="(item, key) in catalog.periodicidadPagosCapital" :key="key"
														:value="item.item_key" :text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-8">
												<label>periodicidadPagosInteres:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.periodicidadPagosInteres">
													<vs-select-item v-for="(item, key) in catalog.periodicidadPagosInteres" :key="key"
														:value="item.item_key" :text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-4">
												<label for="tipoMoneda">tipoMoneda:</label>
												<vs-select class="w-full" v-model.lazy="form.informacionSolicitada.datosOperacion.tipoMoneda">
													<vs-select-item v-for="(item, key) in catalog.tipoMoneda" :key="key" :value="item.item_key"
														:text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-4">
												<label class='text-sm' for="montoInicialPrestamoMonedaOrigen">montoInicialPrestamoMonedaOrigen:
													<button type='button' class="btn btn-xm p-0 text-primary"
														@click="detailField('montoInicialPrestamoMonedaOrigen')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.montoInicialPrestamoMonedaOrigen" />
											</div>
											<div class="form-group col-4">
												<label class='text-sm'
													for="montoInicialPrestamoValorizadoMonedaNacional">montoInicialPrestamoValorizadoMonedaNacional:
													<button type='button' class="btn btn-xm p-0 text-primary"
														@click="detailField('montoInicialPrestamoValorizadoMonedaNacional')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.montoInicialPrestamoValorizadoMonedaNacional" />
											</div>
											<div class="form-group col-4">
												<label for="tipoCambio">tipoCambio: <button type='button' class="btn btn-xm p-0 text-primary"
														@click="detailField('tipoCambio')"><em class="material-icons">info</em></button></label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.tipoCambio" />
											</div>
											<div class="form-group col-8">
												<label>tipoTasaInteres:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.tipoTasaInteres">
													<vs-select-item v-for="(item, key) in catalog.tipoTasaInteres" :key="key"
														:value="item.item_key" :text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-4">
												<label for="valorTasaOriginalmentePactada">valorTasaOriginalmentePactada: <button type='button'
														class="btn btn-xm p-0 text-primary"
														@click="detailField('valorTasaOriginalmentePactada')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.valorTasaOriginalmentePactada" />
											</div>
											<div class="form-group col-4">
												<label for="valorTasaInteresAplicablePeriodo">valorTasaInteresAplicablePeriodo: <button
														type='button' class="btn btn-xm p-0 text-primary"
														@click="detailField('valorTasaInteresAplicablePeriodo')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.valorTasaInteresAplicablePeriodo" />
											</div>
											<div class="form-group col-4">
												<label for="tasaInteresReferencia">tasaInteresReferencia:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.tasaInteresReferencia">
													<vs-select-item v-for="(item, key) in catalog.tasaInteresReferencia" :key="key"
														:value="item.item_key" :text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-4">
												<label for="ajusteTasaReferencia">ajusteTasaReferencia: <button type='button'
														class="btn btn-xm p-0 text-primary" @click="detailField('ajusteTasaReferencia')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="text" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.ajusteTasaReferencia" />
											</div>
											<div class="form-group col-4">
												<label for="frecuenciaRevisionTasa">frecuenciaRevisionTasa: <button type='button'
														class="btn btn-xm p-0 text-primary" @click="detailField('frecuenciaRevisionTasa')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="text" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.frecuenciaRevisionTasa" />
											</div>
											<div class="form-group col-4">
												<label for="importeComisionPactada">importeComisionPactada: <button type='button'
														class="btn btn-xm p-0 text-primary" @click="detailField('importeComisionPactada')"><em
															class="material-icons">info</em></button></label>
												<vs-input type="text" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.importeComisionPactada" />
											</div>
											<div class="form-group col-4" v-if="form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 101
											|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 102">
												<label for="tipoDisposicionCredito">tipoDisposicionCredito:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosOperacion.tipoDisposicionCredito">
													<vs-select-item v-for="(item, key) in catalog.tipoDisposicionCredito" :key="key"
														:value="item.item_key" :text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-12">
												<label for="destinoRecursos">destinoRecursos: <button type='button'
														class="btn btn-xm p-0 text-primary" @click="detailField('destinoRecursos')"><em
															class="material-icons">info</em></button></label>
												<vs-textarea type="text" name="" class="w-full" placeholder=""
													v-model.lazy="form.informacionSolicitada.datosOperacion.destinoRecursos" />
											</div>
										</div>

										<div v-if="form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 103
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 104
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 105
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 106
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 107
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 108
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 109" class="col-12 p-0 row m-0">
											<vs-divider>
												<h6>VI. SECCIÓN DE DATOS DE SEGUIMIENTO DEL PRÉSTAMO</h6>
											</vs-divider>
											<div class="form-group col-4">
												<label for="saldoInsolutoInicioPeriodo">saldoInsolutoInicioPeriodo:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.saldoInsolutoInicioPeriodo" />
											</div>
											<div class="form-group col-4">
												<label for="capitalExigible">capitalExigible:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.capitalExigible" />
											</div>
											<div class="form-group col-4">
												<label for="interesesExigibles">interesesExigibles:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.interesesExigibles" />
											</div>
											<div class="form-group col-4">
												<label for="pagosCapital">pagosCapital:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.pagosCapital" />
											</div>
											<div class="form-group col-4">
												<label for="interesePagados">interesePagados:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.interesePagados" />
											</div>
											<div class="form-group col-4">
												<label for="otrasComisionesPagadas">otrasComisionesPagadas:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.otrasComisionesPagadas" />
											</div>
											<div class="form-group col-4">
												<label for="interesesDevengadosNoPagados">interesesDevengadosNoPagados:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.interesesDevengadosNoPagados" />
											</div>
											<div class="form-group col-4">
												<label for="saldoinsolutoCierrePeriodo">saldoinsolutoCierrePeriodo:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.saldoinsolutoCierrePeriodo" />
											</div>
											<div class="form-group col-4">
												<label for="porcentajeDispuestoCredito">porcentajeDispuestoCredito:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.porcentajeDispuestoCredito" />
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">fechaUltimoPagoRealizado:</label>
												<datepicker placeholder="fechaUltimoPagoRealizado" :language="lang_es"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.fechaUltimoPagoRealizado"
													format="yyyyMMdd" />
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">fechaPagoInmediatoSiguiente:</label>
												<datepicker placeholder="fechaPagoInmediatoSiguiente" :language="lang_es"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.fechaPagoInmediatoSiguiente"
													format="yyyyMMdd" />
											</div>
											<div class="form-group col-4">
												<label for="montoPagoInmediatoSiguiente">montoPagoInmediatoSiguiente:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosSeguimientoPrestamo.montoPagoInmediatoSiguiente" />
											</div>
										</div>

										<div v-if="form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 101
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 102
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 103
										|| form.informacionSolicitada.identificarPrestamo.estatusPrestamo == 109" class="col-12 p-0 row m-0">
											<vs-divider>
												<h6>VII. SECCIÓN DE DATOS DE IDENTIFICACIÓN DE LAS GARANTÍAS DEL
													PRÉSTAMO</h6>
											</vs-divider>
											<div class="form-group col-6">
												<label>tipoGarantia:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionGarantiasPrestamo.tipoGarantia">
													<vs-select-item v-for="(item, key) in catalog.tipoGarantia" :key="key" :value="item.item_key"
														:text="item.item_key + ' - ' + item.item_description" />
												</vs-select>
											</div>
											<div class="form-group col-4">
												<label for="montoPagoInmediatoSiguiente">montoPagoInmediatoSiguiente:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionGarantiasPrestamo.montoPagoInmediatoSiguiente" />
											</div>
											<div class="form-group col-4">
												<label for="valorActualizado">valorActualizado:</label>
												<vs-input type="number" name="" class="w-full"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionGarantiasPrestamo.valorActualizado" />
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">fechaEvaluacion:</label>
												<datepicker placeholder="fechaEvaluacion" :language="lang_es"
													v-model.lazy="form.informacionSolicitada.datosIdentificacionGarantiasPrestamo.fechaEvaluacion"
													format="yyyyMMdd" />
											</div>
										</div>

										<div class="form-group col-12">
											<vs-button color="success" @click="sendForm">Guardar</vs-button>
										</div>
									</form>
								</div>
								<div class="tab-pane" id="nav-envio" role="tabpanel" aria-labelledby="nav-envio-tab">
									<h2 class="">Envio periodo:</h2><br>
									<form class="border-bottom form-group row">
										<div class="form-group col-4">
											<label class="vs-input--label">inicioPeriodo:</label>
											<datepicker placeholder="inicioPeriodo" :language="lang_es" v-model.lazy="envio.inicioPeriodo"
												format="yyyy-MM-dd" value-type='format' />
										</div>
										<div class="form-group col-4">
											<label class="vs-input--label">finPeriodo:</label>
											<datepicker placeholder="finPeriodo" :language="lang_es" v-model.lazy="envio.finPeriodo"
												format="yyyy-MM-dd" value-type='format' />
										</div>
										<div class="form-group col-4">
											<label class="vs-input--label">Cargar Periodo:</label><br>
											<vs-button @click="getPeriod">Cargar</vs-button>
										</div>
									</form>
									<div class="row">
										<table class="table table-striped">
											<caption aria-hidden="true" v-if="false">Reportes regulatorios consultados al periodo establecido
											</caption>
											<thead>
												<tr>
													<th>Id</th>
													<th>Estatus prestamo</th>
													<th>Fecha de actualizacion</th>
													<th>Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(row, i) in this.loansObtained" v-bind:key="i">
													<td>
														<vs-button @click="detailPeriod(row.id)">
															#{{ row.id }}
														</vs-button>
													</td>
													<td>{{ row.estatus_prestamo }}</td>
													<td>{{ row.fecha_actualizacion_estatus }}</td>
													<td>
														<vs-button @click="deleteReport(row)" color='danger' size='small'>
															<feather-icon icon="TrashIcon"
																svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" />
														</vs-button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="row">
										<div class="form-check form-check-inline mr-5 mt-5">
											<div class="form-group col-12">
												<vs-button @click="showPayload" color='primary'>
													Previsualización del periodo
												</vs-button>
											</div>
										</div>
										<div class="col-12 my-5">
											<h4 class="mr-10 inline">Tipo de envio: </h4>
											<div class="form-check form-check-inline mr-5">
												<label class="form-check-label">
													<vs-input class="form-check-input" type="radio" name='radioSubmitType' v-model="submitType"
														value="envio" />
													envio
												</label>
											</div>
											<div class="form-check form-check-inline mr-5">
												<label class="form-check-label">
													<vs-input class="form-check-input" type="radio" name='radioSubmitType' v-model="submitType"
														value="envio-vacio" /> envio-vacio
												</label>
											</div>
											<div class="form-check form-check-inline mr-5">
												<label class="form-check-label">
													<vs-input class="form-check-input" type="radio" name='radioSubmitType' v-model="submitType"
														value="correccion" /> correccion
												</label>
											</div>
										</div>
										<div class="col-12 my-5" v-if="submitType == 'correccion'">
											<div class="form-group">
												<label for="folio">Folio:</label>
												<vs-input type="text" class="w-full" name="folio" id="folio" aria-describedby="folio"
													placeholder="" v-model="folio" />
											</div>
										</div>
									</div>
									<form class="border-bottom form-group row">
										<div class="form-group col-4">
											<vs-button @click="sendPeriod" color='success'>
												ENVIAR
											</vs-button>
										</div>
									</form>
									<div v-if="jsonResponseSitiapi != null">
										<h3 class="">Respuesta:</h3><br>
										<div v-html="$sanitizeHtml(jsonResponseSitiapi)"></div>
									</div>
								</div>
								<div class="tab-pane" id="nav-follow" role="tabpanel" aria-labelledby="nav-follow-tab">
									<seguimiento :folioProp='folio'></seguimiento>
								</div>
							</div>
						</div>
					</vs-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
import {
	es
} from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import seguimiento from '@views/admin/reportes-regulatorios/seguimiento'
import syntaxHighlight from "@mixins/syntaxHighlightJSON";
import Swal from 'sweetalert2';

export default {
	name: 'reportes-regulatorios-r08',
	components: {
		seguimiento,
		Datepicker,
	},
	mixins: [syntaxHighlight],
	created() {
		this.addLibraries();
	},
	beforeMount() {
		let date = new Date();
		let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
		let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
		this.envio.inicioPeriodo = firstDay;
		this.envio.finPeriodo = lastDay;
		this.form.informacionSolicitada.identificarPrestamo.fechaActualizacionEstatus = date;
		this.form.informacionSolicitada.datosOperacion.fechaContratacionApertura = date;
		this.form.informacionSolicitada.datosOperacion.fechaVencimiento = date;
		this.form.informacionSolicitada.datosSeguimientoPrestamo.fechaUltimoPagoRealizado = date;
		this.form.informacionSolicitada.datosSeguimientoPrestamo.fechaPagoInmediatoSiguiente = date;
		this.form.informacionSolicitada.datosIdentificacionGarantiasPrestamo.fechaEvaluacion = date;
	},
	mounted() {
		this.initInstance();
		axios.get('/api/sitiapi/catalogs/R08/842').then(response => {
			this.catalog.estatusPrestamo = response.data.filter((e) => e.field == 6);
			this.catalog.tipoPrestamista = response.data.filter((e) => e.field == 8);
			this.catalog.paisOrigen = response.data.filter((e) => e.field == 12);
			this.catalog.clasificacionContable = response.data.filter((e) => e.field == 14);
			this.catalog.periodicidadPagosCapital = response.data.filter((e) => e.field == 17);
			this.catalog.periodicidadPagosInteres = response.data.filter((e) => e.field == 18);
			this.catalog.tipoMoneda = response.data.filter((e) => e.field == 19);
			this.catalog.tipoTasaInteres = response.data.filter((e) => e.field == 23);
			this.catalog.tasaInteresReferencia = response.data.filter((e) => e.field == 26);
			this.catalog.tipoDisposicionCredito = response.data.filter((e) => e.field == 30);
			this.catalog.tipoGarantia = response.data.filter((e) => e.field == 44);
		}).catch(error => {
			console.log(error);
		});
	},
	data() {
		return {
			catalog: {
				estatusPrestamo: [],
				tipoPrestamista: [],
				paisOrigen: [],
				clasificacionContable: [],
				periodicidadPagosCapital: [],
				tipoMoneda: [],
				tipoTasaInteres: [],
				tasaInteresReferencia: [],
				tipoDisposicionCredito: [],
				tipoGarantia: []
			},
			form: {
				identificadorReporte: {
					inicioPeriodo: '',
					finPeriodo: '',
					// claveInstitucion: '065509', //QA
					claveInstitucion: '065028',
					reporte: '842',
				},
				informacionSolicitada: {
					identificarPrestamo: {
						identificadorPrestamo: null,
						estatusPrestamo: 101,
						fechaActualizacionEstatus: '',
					},
					datosIdentificacionPrestamista: {
						tipoPrestamista: '',
						nombreRazonDenominacionSocial: '',
						apellidoPaterno: '',
						apellidoMaterno: '',
						paisOrigen: 484,
					},
					datosCuenta: {
						identificador_cuenta: 0,
					},
					datosOperacion: {
						clasificacionContable: 0,
						fechaContratacionApertura: '',
						fechaVencimiento: '',
						periodicidadPagosCapital: 0,
						periodicidadPagosInteres: 0,
						tipoMoneda: 0,
						montoInicialPrestamoMonedaOrigen: 0,
						montoInicialPrestamoValorizadoMonedaNacional: 0,
						tipoCambio: 0,
						tipoTasaInteres: 0,
						valorTasaOriginalmentePactada: 0,
						valorTasaInteresAplicablePeriodo: 0,
						tasaInteresReferencia: 0,
						ajusteTasaReferencia: '',
						frecuenciaRevisionTasa: 0,
						importeComisionPactada: 0,
						tipoDisposicionCredito: 0,
						destinoRecursos: ''
					},
					datosSeguimientoPrestamo: {
						saldoInsolutoInicioPeriodo: 0,
						capitalExigible: 0,
						interesesExigibles: 0,
						pagosCapital: 0,
						interesePagados: 0,
						otrasComisionesPagadas: 0,
						interesesDevengadosNoPagados: 0,
						saldoInsolutoCierrePeriodo: 0,
						porcentajeDispuestoCredito: 0,
						fechaUltimoPagoRealizado: '',
						fechaPagoInmediatoSiguiente: '',
						montoPagoInmediatoSiguiente: 0
					},
					datosIdentificacionGarantiasPrestamo: {
						tipoGarantia: 0,
						valorInicial: 0,
						valorActualizado: 0,
						fechaEvaluacion: '',
					},
				},
				auto: '<auto. gen.>',
				nonauto: '<non auto. gen.>',
				optional: 'Opcional',
			},
			lang_es: es,
			envio: {
				inicioPeriodo: '',
				finPeriodo: '',
			},
			folio: '',
			loansObtained: [],
			jsonResponseSitiapi: null,
			submitType: 'envio',
		}
	},
	methods: {
		detailField(field) {
			let html = '';
			switch (field) {
				case 'nombreRazonDenominacionSocial':
					html = `<strong>NOMBRE (S)/RAZÓN O DENOMINACIÓN SOCIAL</strong>
					Se refiereal nombre de la persona física o moral que realizó el préstamo a la IFC. 
					Este dato deberá ser igual cada vez que se haga referencia a la misma persona dentro de este reporte R08, de lo contrario se considerará como inconsistencia. 
					</br><strong>Personas físicas:</strong></br> Se  deberá  reportar  el  nombre o  nombres del  prestamista,  sin  apellidos  con  letras mayúsculas, sin abreviaciones, sin guiones, comas, puntos ni acentos. No se deberá incluir  ningún  tipo  de  título  como  Licenciado,  Don,  Señor,  Viuda,  entre  otros. Adicionalmente deberá haber un solo espacio de separación para los que tiene dos o más nombres.Ejemplo:  si  el  nombre  completo  del  otorgante  del  préstamo  es  José  María  Peña García, se reportará “JOSE MARIA”.
					</br><strong>Personas morales:</strong></br> Se  deberá  reportar la  razón  socialdel  prestamista,  con  letras  mayúsculas  sin abreviaciones, sin guiones, comas, puntos, ni acentos, tampoco se deberá incluir el tipo de sociedad y se deberá separar cada palabra por un solo espacio.El  nombre  (s)/razón  o  denominación  social,  se  truncará  cuando  la  longitud  supere los 200 caracteres.Ejemplo: Si la razón social de la persona moral es “TIENDITA FINANCIERA S.A. DE C.V.” se reportará: “TIENDITAFINANCIERA”.El llenado de este campo es obligatorio si en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”.`;
					break;
				case 'apellidoPaterno':
					html = `<strong>APELLIDOS PATERNOS</strong></br> Se deberá  reportar  el o  los  apellidos  paternos  del  otorgante  del  préstamo  sin abreviaciones, sin  guiones,  comas,  puntos  ni acentos  y  se  deberá  reportar  en mayúsculas. Este campose truncará cuando la longitud supere los 60 caracteres.Ejemplo: si el nombre completo del prestamistaes José María Peña García, se deberá reportar “PEÑA”.Si  el prestamistano  cuenta  con  apellido  paterno,  entonces  este  campo no se reportará  y  se  deberá reportar la información correspondiente en el  campo  11“APELLIDOS MATERNOS”. Cuando se trate de personas morales este campo no se deberá reportar.`;
					break;
				case 'apellidoMaterno':
					html = `<strong>APELLIDOS MATERNOS</strong></br> Se deberá reportar  el  o  los  apellidos  maternos  del  otorgante  del  préstamo  sin abreviaciones, sin  guiones,  comas,  puntos  ni acentos  y  se  deberá  reportar  en mayúsculas. Este campo se truncará cuando la longitud supere los 60 caracteres.Ejemplo: si el nombre completo del prestamistaes José María Peña García, se debe reportar “GARCIA”.Si el prestamista no cuenta con apellidomaterno, este campo no se reportará, y se deberá reportar la   información   correspondiente   en el  campo  10  “APELLIDOS PATERNOS”. Cuando se trate de personas morales este campo no se deberá reportar.`;
					break;
				case 'identificadorCuenta':
					html = `<strong>IDENTIFICADOR DE LA CUENTA DONDE SE RECIBE EL PRÉSTAMO</strong></br> Se refiere al identificador único dondela IFC recibió los recursos del préstamo.Este identificador se reportará sin comas, ni guiones ni espacios. Ejemplo:Si se desea reportar 1014-0295-25, se deberá reportar: 1014029525El llenado de este campo es obligatorio si en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta” y su longitud debe ser de hasta 50 caracteres.`;
					break;
				case 'montoInicialPrestamoMonedaOrigen':
					html = `<strong>MONTO INICIAL DEL PRÉSTAMO EN MONEDA ORIGEN</strong></br> Se  refiere  al  importe  total  del  monto  inicial  del  préstamo o  línea  de  crédito en  la moneda de origen.Se  deberá  reportar este  camporedondeado  a  cuatro  decimales,  en  su  caso,y  sin signo de pesos ni comas, únicamente se aceptará el punto como caracter especial para separar los decimales.Para líneas de crédito con varias disposiciones se deberá reportar el monto total de la   línea   de   crédito   independientemente   de   que   se   puedan   realizar   varias disposiciones.Ejemplo: Siel monto es por $236,569.68001, se deberá reportar 236569.6800Si el monto es por $425,132.00, se deberá reportar 425132El llenado de este campo es obligatorio si en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”o 102 “Alta reestructura”y su longitud debe ser de hasta 24caracteres.`;
					break;
				case 'montoInicialPrestamoValorizadoMonedaNacional':
					html = `<strong>MONTO INICIAL DEL PRÉSTAMO VALORIZADO EN MONEDA NACIONAL</strong></br> Se  refiere  al  importe  total  del  monto  inicial del  préstamo valorizado  en  moneda nacional. Para líneas de crédito con varias disposiciones se deberá reportar el monto total de la   línea   de crédito   independientemente   de   que   se   puedan   realizar   varias disposiciones.Se  deberá  reportar este  camporedondeado  a  cuatro  decimales,  en  su  caso,y  sin signo de pesos ni comas, únicamente se aceptará el punto como caracter especial para separar los decimales.Ejemplo: -Siel monto es por $236,569.68001, se deberá reportar 236569.6800-Si el monto es por $425,132.00, se deberá reportar 425132Para aquellos  préstamos  cuya  moneda  de  origen  sea  moneda  nacional,  se  deberá reportar nuevamente el importe en moneda nacional.El llenado de este campo es obligatorio si en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”o 102 “Alta reestructura”y su longitud debe ser de hasta 24caracteres.Para  créditos  otorgados  en  moneda  extranjera  se  deberá  valorizar  al  cierre  del periodo de acuerdo al tipo de cambio que determine el Banco de México.`;
					break;
				case 'tipoCambio':
					html = `<strong>TIPO DE CAMBIO</strong></br> Se  deberá  reportar  el  tipo  de  cambio  o  precio  de  valuación con  el  que  se  pactó  el préstamo, redondeado a cuatro decimales, en su caso,y sin signo de pesos ni comas, únicamente se aceptará el punto como caracter especial para separar los decimales.Ejemplo: -Siel tipo de cambio es 19.24310, se deberá reportar 19.2431Este campo sólo aplica a los préstamos en moneda extranjera; para los movimientos en moneda nacional, este campo deberá reportarse como “1”.El  tipo  de  cambio  utilizado  deberá  considerar  lo  establecido  en  el  Criterio  A-2Aplicación de normas particularescontenido en el Anexo 6 relativo a los criterios de contabilidad para instituciones de financiamiento colectivode la CUITF.El llenado de este campo es obligatorio si en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”o 102 “Alta reestructura”y su longitud debe ser de hasta 8caracteres.`;
					break;
				case 'valorTasaOriginalmentePactada':
					html = `<strong>VALOR DE LA TASA ORIGINALMENTE PACTADA</strong></br> Se  refiere  a  la  tasa  originalmente  pactada  para  el  préstamo,  establecida  en  el contrato.En caso de que el préstamo sea a tasa fija se deberá reportar la tasaanual, sin el signo de  porcentaje  (%), expresado  en  base  cien,  redondeada  acuatro  decimales,en  su caso,y  sin  signos  ni  comas,  únicamente  se  aceptará  el  punto  para  separar  los decimalesy su longitud debe ser de hasta 8caracteres. Ejemplo: si la tasa es 3.14152085% se deberá reportar 3.1415En  caso  de  tratarse  de  una  tasa  diferente  a  una  fija,  este  campo no se  deberá reportar.`;
					break;
				case 'valorTasaInteresAplicablePeriodo':
					html = `<strong>VALOR DE LA TASA DE INTERÉS APLICABLE EN EL PERIODO</strong></br> Se deberá reportar el valor de la tasa de interés aplicable en el periodo sin el signo de  porcentaje  (%),  expresado  en  base  cien,  redondeada  acuatro  decimalesen  su caso, y  sin  signos  ni  comas,  únicamente  se  aceptará  el  punto  para  separar  los decimales.Ejemplo: si la tasa es 3.14152085% se deberá reportar 3.1415.El llenado de este campo es obligatorio si en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”o 102 “Alta reestructura”y su longitud debe ser de hasta 8caracteres.`;
					break;
				case 'ajusteTasaReferencia':
					html = `<strong>AJUSTE EN LA TASA DE REFERENCIA</strong></br> Corresponde  al  ajuste  que  se  le  aplicará  a  la  tasa  de  referencia,  ya  sea  sumándole, restándole algunos puntos porcentuales o si se multiplica por un factor.Se   deberá   reportarsin   el   signo   de   porcentaje   (%),   expresado   en   base   cien, redondeada  ados  decimales,  considerando  primero  el  signo  de  “+”,  “-”,  o  “*” dependiendo  de  si  los  puntos  se  suman, se  restan  o si  es un  factor  que  multiplica, seguido por los puntos porcentuales o el factor que multiplica.Ejemplo:-Para TIIE+2.5% se deberá reportar “+2.50”-Para TIIE-1.0% se deberá reportar “-1.00”-Si es 2TIIE+2.5% se deberá reportar “*2+2.50”No se deberán separar los dígitos por comasni espacios.En caso de que la tasa de referencia no tenga ajuste este campose deberá reportar concero.El  llenado  deestecampo  es  obligatorio  y su  longitud debe ser menor  o  igual  a  10 caracteressi en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”o 102 “Alta reestructura”.`;
					break;
				case 'frecuenciaRevisionTasa':
					html = `<strong>FRECUENCIA DE LA REVISIÓN DE LA TASA</strong></br> Se refiere al periodo en días naturales que transcurren entre cada revisión de la tasadel préstamo.Se debe reportar el número de días naturales efectivos que transcurren entre cada revisión de la tasa del préstamo estipulado previamente en el contrato. No se deberá incluir  ningún  tipo  de  guiones,  ni símbolos,  ni  espaciosy  su  longitud  debe  ser  de hasta 4caracteres.Ejemplo:-Para 15 días naturales se deberá reportar 15La  revisión  de  tasa  no  se  refiere  a  modificaciones  de  los  términos  originalmente pactados  en  el  contrato,  en  caso  de  que  la  tasa  sea  fija  este  campo no se  deberá reportar.`;
					break;
				case 'importeComisionPactada':
					html = `<strong>IMPORTE DE LA COMISIÓN PACTADA</strong></br> Se  refiere  a  la  suma  de  los  importes  de  todos  aquellos  gastos  y  comisiones  por apertura del crédito, valorizados en moneda nacional.Se  deberá  reportar  este  campo redondeado  a  cuatro  decimales,  en  su  caso, y  sin signo  de  pesos  ni  comas,  únicamente  se  aceptará  el  punto  para  separar  los decimales. Ejemplo: -Siel monto es por $236,569.68001, se deberá reportar 236569.6800-Si el monto es por $425,132.00, se deberá reportar 425132El llenado de este campo es obligatorio si en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”o 102 “Alta reestructura”y su longitud debe ser de hasta 24caracteres.Para  registros  en  moneda  extranjera  se  deberá  valorizar  al  cierre  del  periodo  de acuerdo al tipo de cambio que determine el Banco de México.`;
					break;
				case 'destinoRecursos':
					html = `<strong>DESTINO DE LOS RECURSOS</strong></br> Se    deberá registraruna    descripción    general,    de    máximo    200    caracteresalfanuméricos, respecto al uso que dará la Institución a los recursos obtenidos por el préstamo solicitado.El llenado de este campo es obligatoriosi en el campo 6 “ESTATUS DEL PRÉSTAMO”, se registra la clave 101 “Alta”o 102 “Alta reestructura”.`;
					break;
			}

			Swal.fire({
				title: field,
				html: html,
				showCloseButton: true,
				confirmButtonText: 'Cerrar',
				confirmButtonColor: '#FFBA00',
			});
		},
		toUpperCase(e) {
			e.target.value = e.target.value.toUpperCase()
		},
		addLibraries() {
			//TODO: Add css, js libraries here
		},
		initInstance() {
			const self = this;
			var triggerTabList = [].slice.call(document.querySelectorAll('#nav-tab button'));
			triggerTabList.forEach(function (triggerEl) {
				var tabTrigger = new bootstrap.Tab(triggerEl);
				triggerEl.addEventListener('click', function (event) {
					event.preventDefault();
					tabTrigger.show();
					$('#nav-tabContent .tab-pane').hide();
					$(tabTrigger._element.dataset.bsTarget).show();
				});
			});

			$('form :input').change(function (e) {
				if (e.target.value === "" || e.target.value === 0) {
					e.target.classList.add("bg-danger");
					e.target.classList.remove("bg-success-light");
				} else {
					e.target.classList.remove("bg-danger");
					e.target.classList.add("bg-success-light");
				}
			});
		},
		async sendForm() {
			// console.log('sendForm');
			if (this.validateForm()) {
				let self = this;
				try {
					await axios.post('/api/sitiapi/r08/loans-obtained', this.form.informacionSolicitada).then(
						response => {
							this.$refs.formR08.reset();
							swal("Done", 'Nuevo registro agregado correctamente.', "success");
							// console.log(response);
						});
				} catch (error) {
					console.log(error);
					if (error.response.status === 400) {
						await swal("Formulario incompleto ó incorrecto", JSON.stringify(error.response.data),
							"warning")
					} else if (error.response.status === 404) {
						// await swal("Folio incorrecto", JSON.stringify(error.response.data),
						await swal("Error #404", 'Folio incorrecto',
							"warning")
					} else if (error.response.status === 500) {
						await swal("Error", JSON.stringify(error.response.data),
							"warning")
					}
				}
			}
		},
		validateForm() {
			let valid = true;
			let estatusPrestamo = this.form.informacionSolicitada.identificarPrestamo.estatusPrestamo;
			if (estatusPrestamo == 101) {
				valid &&= this.validateIdentificarPrestamo();
				valid &&= this.validateDatosOperacion();
			}
			return valid;
		},
		validateIdentificarPrestamo() {
			return true;
		},
		validateDatosOperacion() {
			let valid = true;

			valid = this.validateDouble(this.form.informacionSolicitada.datosOperacion.montoInicialPrestamoMonedaOrigen);
			if (!valid) {
				swal("Error de formato", 'Campo: montoInicialPrestamoMonedaOrigen', 'warning');
				return valid;
			}

			valid = this.validateDouble(this.form.informacionSolicitada.datosOperacion.montoInicialPrestamoValorizadoMonedaNacional);
			if (!valid) {
				swal("Error de formato", 'Campo: montoInicialPrestamoValorizadoMonedaNacional', 'warning');
				return valid;
			}

			valid = this.validateDouble(this.form.informacionSolicitada.datosOperacion.tipoCambio);
			if (!valid) {
				swal("Error de formato", 'Campo: tipoCambio', 'warning');
				return valid;
			}

			return valid;
		},
		validateDouble(n) {
			return Number(n) && n.toString().split('.')[1]?.length === 4;
		},
		async getPeriod() {
			this.$vs.loading();
			await axios.get(
				`/api/sitiapi/r08/loans-obtained/period/${this.envio.inicioPeriodo.toISOString()}/${this.envio.finPeriodo.toISOString()}`
			)
				.then(response => {
					this.loansObtained = response.data;
					return this.loansObtained;
				});
			this.$vs.loading.close();
		},
		detailPeriod(id) {
			let detail = this.loansObtained.find(row => row.id == id);
			Swal.fire({
				title: `Datos en la B.D. ID#${id}:`,
				html: `<h3><span style="color:red">¡Datos sin formato!</span></h3> ${this.syntaxHighlight(detail)}`,
				width: '60%',
			});
		},
		showPayload() {
			Swal.fire({
				title: 'Payload preview:',
				html: `${this.syntaxHighlight(this.getPayload())}`,
			});
		},
		getPayload() {
			let json_sitiapi = {
				identificadorReporte: {
					inicioPeriodo: this.envio.inicioPeriodo.toISOString().split('T')[0].replaceAll('-', ''),
					finPeriodo: this.envio.finPeriodo.toISOString().split('T')[0].replaceAll('-', ''),
					// claveInstitucion: '065509', //QA
					claveInstitucion: '065028',
					reporte: '842',
				},
				informacionSolicitada: []
			};
			if (this.submitType == 'envio-vacio') {
				return {
					identificadorReporte: {
						...json_sitiapi.identificadorReporte
					}
				};
			} else {
				for (const ix in this.loansObtained) {
					let loanObtained = this.loansObtained[ix];
					let informacionSolicitada = null;
					//TODO: This switch can be reduced by an abstract of cases
					//REGEX: :\s+loanObtained\.?[a-z]+_?[A-Z]+
					switch (loanObtained.estatus_prestamo) {
						case 101:
							informacionSolicitada = {
								...this.getIdentificarPrestamo(loanObtained),
								datosIdentificacionPrestamista: { // III
									tipoPrestamista: loanObtained.tipo_prestamista,
									nombreRazonDenominacionSocial: loanObtained.nombre_razon_denominacion_social,
									apellidoPaterno: loanObtained.apellido_paterno,
									apellidoMaterno: loanObtained.apellido_materno,
									paisOrigen: loanObtained.pais_origen,
								},
								datosCuenta: { // IV
									identificadorCuenta: loanObtained.identificador_cuenta,
								},
								...this.getDatosOperacion(loanObtained),
								...this.getDatosIdentificacionGarantiasPrestamo(loanObtained),
							};
							break;
						case 102:
							informacionSolicitada = {
								...this.getIdentificarPrestamo(loanObtained),
								datosCuenta: { // IV
									identificadorCuenta: loanObtained.identificador_cuenta,
								},
								...this.getDatosOperacion(loanObtained),
								...this.getDatosIdentificacionGarantiasPrestamo(loanObtained),
							};
							break;
						case 103:
							informacionSolicitada = {
								...this.getIdentificarPrestamo(loanObtained),
								datosCuenta: { // IV
									identificadorCuenta: loanObtained.identificador_cuenta,
								},
								...this.getDatosOperacion(loanObtained),
								datosSeguimientoPrestamo: { // VI
									saldoInsolutoInicioPeriodo: loanObtained.saldo_insoluto_inicio_periodo,
									capitalExigible: loanObtained.capital_exigible,
									interesesExigibles: loanObtained.intereses_exigibles,
									pagosCapital: loanObtained.pagos_capital,
									interesePagados: loanObtained.interese_pagados,
									otrasComisionesPagadas: loanObtained.otras_comisiones_pagadas,
									interesesDevengadosNoPagados: loanObtained.intereses_devengados_no_pagados,
									saldoInsolutoCierrePeriodo: loanObtained.saldo_insoluto_cierre_periodo,
									porcentajeDispuestoCredito: loanObtained.porcentaje_dispuesto_credito,
									fechaUltimoPagoRealizado: this.formatFechaReport(loanObtained.fecha_ultimo_pago_realizado),
									fechaPagoInmediatoSiguiente: this.formatFechaReport(loanObtained.fecha_pago_inmediato_siguiente),
									montoPagoInmediatoSiguiente: loanObtained.monto_pago_inmediato_siguiente
								},
								...this.getDatosIdentificacionGarantiasPrestamo(loanObtained),
							};
							break;
						case 104:
							informacionSolicitada = {
								...this.getIdentificarPrestamo(loanObtained),
								datosSeguimientoPrestamo: { // VI
									saldoInsolutoInicioPeriodo: loanObtained.saldo_insoluto_inicio_periodo,
									capitalExigible: loanObtained.capital_exigible,
									interesesExigibles: loanObtained.intereses_exigibles,
									pagosCapital: loanObtained.pagos_capital,
									interesePagados: loanObtained.interese_pagados,
									otrasComisionesPagadas: loanObtained.otras_comisiones_pagadas,
									interesesDevengadosNoPagados: loanObtained.intereses_devengados_no_pagados,
									saldoInsolutoCierrePeriodo: loanObtained.saldo_insoluto_cierre_periodo,
									porcentajeDispuestoCredito: loanObtained.porcentaje_dispuesto_credito,
									fechaUltimoPagoRealizado: this.formatFechaReport(loanObtained.fecha_ultimo_pago_realizado),
									fechaPagoInmediatoSiguiente: this.formatFechaReport(loanObtained.fecha_pago_inmediato_siguiente),
									montoPagoInmediatoSiguiente: loanObtained.monto_pago_inmediato_siguiente
								},
							};
							break;
						case 105:
						case 106:
						case 107:
						case 108:
							informacionSolicitada = {
								...this.getIdentificarPrestamo(loanObtained),
								datosSeguimientoPrestamo: { // VI
									saldoInsolutoInicioPeriodo: loanObtained.saldo_insoluto_inicio_periodo,
									capitalExigible: loanObtained.capital_exigible,
									interesesExigibles: loanObtained.intereses_exigibles,
									pagosCapital: loanObtained.pagos_capital,
									interesePagados: loanObtained.interese_pagados,
									otrasComisionesPagadas: loanObtained.otras_comisiones_pagadas,
									interesesDevengadosNoPagados: loanObtained.intereses_devengados_no_pagados,
									saldoInsolutoCierrePeriodo: loanObtained.saldo_insoluto_cierre_periodo,
									porcentajeDispuestoCredito: loanObtained.porcentaje_dispuesto_credito,
									fechaUltimoPagoRealizado: this.formatFechaReport(loanObtained.fecha_ultimo_pago_realizado),
									fechaPagoInmediatoSiguiente: this.formatFechaReport(loanObtained.fecha_pago_inmediato_siguiente),
									montoPagoInmediatoSiguiente: loanObtained.monto_pago_inmediato_siguiente
								},
							};
							break;
						case 109:
							informacionSolicitada = {
								...this.getIdentificarPrestamo(loanObtained),
								datosCuenta: { // IV
									identificadorCuenta: loanObtained.identificador_cuenta,
								},
								...this.getDatosOperacion(loanObtained),
								datosSeguimientoPrestamo: { // VI
									saldoInsolutoInicioPeriodo: loanObtained.saldo_insoluto_inicio_periodo,
									capitalExigible: loanObtained.capital_exigible,
									interesesExigibles: loanObtained.intereses_exigibles,
									pagosCapital: loanObtained.pagos_capital,
									interesePagados: loanObtained.interese_pagados,
									otrasComisionesPagadas: loanObtained.otras_comisiones_pagadas,
									interesesDevengadosNoPagados: loanObtained.intereses_devengados_no_pagados,
									saldoInsolutoCierrePeriodo: loanObtained.saldo_insoluto_cierre_periodo,
									porcentajeDispuestoCredito: loanObtained.porcentaje_dispuesto_credito,
									fechaUltimoPagoRealizado: this.formatFechaReport(loanObtained.fecha_ultimo_pago_realizado),
									fechaPagoInmediatoSiguiente: this.formatFechaReport(loanObtained.fecha_pago_inmediato_siguiente),
									montoPagoInmediatoSiguiente: loanObtained.monto_pago_inmediato_siguiente
								},
								...this.getDatosIdentificacionGarantiasPrestamo(loanObtained),
							};
							break;
					}
					json_sitiapi.informacionSolicitada.push(informacionSolicitada);
				}
				return json_sitiapi;
			}
		},
		getIdentificarPrestamo(loanObtained) {
			return {
				identificarPrestamo: { // II
					identificadorPrestamo: this.getFormattedIdentificadorPrestamo(loanObtained.id),
					estatusPrestamo: loanObtained.estatus_prestamo,
					fechaActualizacionEstatus: this.formatFechaReport(loanObtained.fecha_actualizacion_estatus),
				}
			}
		},
		getDatosOperacion(loanObtained) {
			let responseDatosOperacion = {
				datosOperacion: { // V
					clasificacionContable: loanObtained.clasificacion_contable,
					fechaContratacionApertura: this.formatFechaReport(loanObtained.fecha_contratacion_apertura),
					fechaVencimiento: this.formatFechaReport(loanObtained.fecha_vencimiento),
					periodicidadPagosCapital: loanObtained.periodicidad_pagos_capital,
					periodicidadPagosInteres: loanObtained.periodicidad_pagos_interes,
					tipoMoneda: loanObtained.tipo_moneda,
					montoInicialPrestamoMonedaOrigen: loanObtained.monto_inicial_prestamo_moneda_origen,
					montoInicialPrestamoValorizadoMonedaNacional: loanObtained.monto_inicial_prestamo_valorizado_moneda_nacional,
					tipoCambio: loanObtained.tipo_cambio,
					tipoTasaInteres: loanObtained.tipo_tasa_interes,
					valorTasaOriginalmentePactada: loanObtained.valor_tasa_originalmente_pactada,
					valorTasaInteresAplicablePeriodo: loanObtained.valor_tasa_interes_aplicable_periodo,
					tasaInteresReferencia: loanObtained.tasa_interes_referencia,
					ajusteTasaReferencia: loanObtained.ajuste_tasa_referencia,
					frecuenciaRevisionTasa: loanObtained.frecuencia_revision_tasa,
					importeComisionPactada: loanObtained.importe_comision_pactada,
					tipoDisposicionCredito: loanObtained.tipo_disposicion_credito,
					destinoRecursos: loanObtained.destino_recursos,
				}
			};
			if (responseDatosOperacion.datosOperacion.tipoTasaInteres == 501) {
				responseDatosOperacion.datosOperacion.tasaInteresReferencia = 0;
			} else {
				delete responseDatosOperacion.datosOperacion.valorTasaOriginalmentePactada;
			}
			return responseDatosOperacion;
		},
		getDatosIdentificacionGarantiasPrestamo(loanObtained) {
			let responseDatosIdentificacionGarantiasPrestamo = {
				datosIdentificacionGarantiasPrestamo: { // VII
					tipoGarantia: loanObtained.tipo_garantia,
					valorInicial: loanObtained.valor_inicial,
					valorActualizado: loanObtained.valor_actualizado,
					fechaEvaluacion: this.formatFechaReport(loanObtained.fecha_evaluacion),
				}
			}
			if (responseDatosIdentificacionGarantiasPrestamo.datosIdentificacionGarantiasPrestamo.tipoGarantia == 808) {
				delete responseDatosIdentificacionGarantiasPrestamo.datosIdentificacionGarantiasPrestamo.valorInicial;
				delete responseDatosIdentificacionGarantiasPrestamo.datosIdentificacionGarantiasPrestamo.valorActualizado;
				delete responseDatosIdentificacionGarantiasPrestamo.datosIdentificacionGarantiasPrestamo.fechaEvaluacion;
			}
			return responseDatosIdentificacionGarantiasPrestamo;
		},
		getFormattedIdentificadorPrestamo(id) {
			return id.toString().padStart(10, '0');
		},
		async sendPeriod() {
			this.sendJson(this.getPayload());
		},
		async deleteReport(report) {
			if (confirm(`¿Esta seguro de eliminar el reporte #${report.id}?`)) {
				this.$vs.loading();
				try {
					await axios.delete(
						`/api/sitiapi/r08/loans-obtained/${report.id}`);
					this.loansObtained.splice(this.loansObtained.indexOf(report), 1);
				} catch (e) {
					await swal("Alerta", JSON.stringify(e.response.data), 'warning');
				}
				this.$vs.loading.close();
			}
		},
		formatFechaReport(date) {
			return date.split(' ')[0].replaceAll('-', '');
		},
		async sendJson(json_sitiapi) {
			this.jsonResponseSitiapi = null;
			let url = '';
			switch (this.submitType) {
				case 'envio':
					url = `/api/sitiapi/IFC/R08/842`;
					break;
				case 'correccion':
					url = `/api/sitiapi/IFC/R08/842/correccion/${this.folio}`;
					break;
				case 'reenvio':
					url = `/api/sitiapi/IFC/R08/842/reenvio/${this.folio}`;
					break;
				case 'envio-vacio':
					url = `/api/sitiapi/IFC/R08/842/envio-vacio`;
					break;
			}
			await this.requestPost(url, json_sitiapi, async (jsonResponse) => {
				this.jsonResponseSitiapi = this.syntaxHighlight(JSON.stringify(jsonResponse, null, 4));
				if (typeof jsonResponse.folio !== 'undefined') {
					this.folio = jsonResponse.folio;
				}
				let jsonToStore = {
					'reportCategory': 'R08',
					'reportCode': '842',
					'reportLabel': `${this.folio}`,
					'type': `${this.submitType}`,
					'jsonSent': json_sitiapi,
					'jsonReceived': jsonReponse ?? {}
				};
				let jsonResponsePersist = await this.requestPost('/api/sitiapi/regulatoryReports',
					jsonToStore, (jsonResponsePersistence) => {
						return jsonResponsePersistence;
					});
				return [jsonResponse, jsonResponsePersist];
			});
		},
		async requestPost(url, data, callback) {
			let rP = await axios.post(url, data)
				.then(response => response.data);
			callback(rP);
		},
	},
}
</script>

<style lang="css">
.text-sm {
	font-size: 0.75rem;
}

.material-icons {
	font-size: 0.9rem;
}

.text-left div,
.p-1,
.px-1,
.swal2-html-container {
	text-align: left;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
	border-color: rgb(31, 116, 255);
}
</style>